/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from '../../hooks'

/**
 * @function
 * @description AlertError
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 24
  const viewBoxHeight = 24
  const [, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id="Group_2074" data-name="Group 2074" transform="translate(-138.601 -1544)">
        <g id="Boundary" transform="translate(138.601 1544)" fill="#f44336" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none"/>
          <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
        </g>
        <path id="Path_alert-circle-outline" data-name="Path / alert-circle-outline" d="M11,15h2v2H11V15m0-8h2v6H11V7m1-5A10,10,0,1,0,22,12,10.01,10.01,0,0,0,12,2m0,18a8,8,0,1,1,8-8,8,8,0,0,1-8,8Z" transform="translate(138.601 1544)" fill={props.fill || '#f44336'} />
      </g>
    </svg>
  )
}
